import { AppBar, Tab, Tabs, useMediaQuery, Theme, Grid } from '@mui/material';
import { Page, PageTitle } from '../../../components';
import { useContext, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { NeighborhoodPriceGuide } from './neighborhood-price-guide';
import { SampleContracts } from './sample-contracts';
import { SpecHomePriceSheet } from './spec-home-price-sheet';
import { PlanBrochure } from './plan-brochure';
import { UpgradePricing } from './upgrade-pricing';
import { LotDetailsReport } from './lot-details-report';
import { PlanCabinetLayout } from './plan-cabinet-layout';
import { UserContext } from '../../../context';
import { InternalJobTitles } from '../../../models/user-types';

export const MarketingMaterialsPage = () => {
  const classes = useStyles();
  const isSmMobile = useMediaQuery('(max-width: 567px)');
  const [selectedTab, setSelectedTab] = useState(0);
  const { user } = useContext(UserContext);
  const isMarketManager = user?.jobTitle === InternalJobTitles.MarketManager;

  return (
    <Page title="Marketing Materials">
      <PageTitle title="Marketing Materials" />
      <AppBar position="static" color="default" component="div" className={classes.tabBar}>
        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_, value) => {
            setSelectedTab(value);
          }}
          aria-label="checklist-tabs"
        >
          <Tab id="brochuresReportsTab" label={isSmMobile ? 'Brochures' : 'Brochures/Reports'} />
        </Tabs>
      </AppBar>
      <div className={classes.tabGroupWrap}>
        {selectedTab === 0 && (
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <NeighborhoodPriceGuide shouldSeeAllNeighborhoods={isMarketManager} />
            </Grid>
            <Grid item xs={12}>
              <SampleContracts shouldSeeAllNeighborhoods={isMarketManager} />
            </Grid>
            <Grid item xs={12}>
              <SpecHomePriceSheet />
            </Grid>
            <Grid item xs={12}>
              <PlanBrochure />
            </Grid>
            <Grid item xs={12}>
              <UpgradePricing shouldSeeAllNeighborhoods={isMarketManager} />
            </Grid>
            <Grid item xs={12}>
              <LotDetailsReport shouldSeeAllNeighborhoods={isMarketManager} />
            </Grid>
            <Grid item xs={12}>
              <PlanCabinetLayout />
            </Grid>
          </Grid>
        )}
      </div>
    </Page>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  tabBar: {
    marginTop: '-1rem',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    marginBottom: theme.spacing(1.5)
  },
  tabGroupWrap: {
    '& .MuiAccordionSummary-root.Mui-expanded': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)'
    },
    '& .MuiAccordionDetails-root': {
      backgroundColor: '#ffffff'
    },
    '& .MuiAccordionSummary-content': {
      '& .MuiTypography-root': {
        color: theme.palette.primary.main
      }
    }
  }
}));
